var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"aup-base-button py-1 px-4 t-micro text-uppercase",class:{
    'solid-orange': (_vm.filled && _vm.color == 'orange' && !_vm.isDisabled),
    'solid-black': (_vm.filled && _vm.color == 'black' && !_vm.isDisabled),
    'solid-white': (_vm.filled && _vm.color == 'white' && !_vm.isDisabled),
    'solid-gray': (_vm.filled && _vm.isDisabled),
    'empty-orange': (!_vm.filled && _vm.color == 'orange' && !_vm.isDisabled),
    'empty-black': (!_vm.filled && _vm.color == 'black' && !_vm.isDisabled),
    'empty-white': (!_vm.filled && _vm.color == 'white' && !_vm.isDisabled),
    'empty-light': (!_vm.filled && _vm.color == 'light' && !_vm.isDisabled),
    'empty-gray': (!_vm.filled && _vm.isDisabled),
    'thin-border-black': (_vm.border == 'thin' && _vm.color == 'black'),
    'thin-border-orange': (_vm.border == 'thin' && _vm.color == 'orange'),
    'no-border': (_vm.border == 'none'),
    'round-border': (_vm.border == 'round'),
    'no-padding': (_vm.noPadding),
    'low-priority': _vm.isLowPriority,
},attrs:{"disabled":_vm.isDisabled,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }